import { BaseApi } from './baseApi';

export class ProductsApi extends BaseApi {
    list(workspaceId, params) {
        return this.get([`/workspaces/${workspaceId}/products`, params]);
    }

    load(workspaceId, productId) {
        return this.get([`/workspaces/${workspaceId}/products/${productId}`]);
    }

    loadBySlug(workspaceId, productSlug, collectionId) {
        return this.get([`/workspaces/${workspaceId}/products/${collectionId}/${productSlug}`]);
    }
}

export default ((options) => new ProductsApi(options))();
